import { render, staticRenderFns } from "./select-datasource-type.vue?vue&type=template&id=bdd529b0&scoped=true"
import script from "./select-datasource-type.vue?vue&type=script&lang=js"
export * from "./select-datasource-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd529b0",
  null
  
)

export default component.exports